<div>
    <span *ngFor="let item of iterateNumbers">
        <i class="la la-star" [ngClass]="colorClass"></i>
    </span>
    <span *ngIf="isHalf">
        <i class="la la-star-half-o" [ngClass]="colorClass"></i>
    </span>
    <ng-container *ngIf="showEmptyStars">
        <span *ngFor="let item of iterateEmptyNumbers">
            <i class="la la-star-o" [ngClass]="colorClass"></i>
        </span>
    </ng-container>
    <strong *ngIf="displayNumber">{{ numberOfStars }}</strong>
</div>
